import { render, staticRenderFns } from "./uploadImgs.vue?vue&type=template&id=23ede0f6&scoped=true&"
import script from "./uploadImgs.vue?vue&type=script&lang=js&"
export * from "./uploadImgs.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgs.vue?vue&type=style&index=0&id=23ede0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ede0f6",
  null
  
)

export default component.exports